import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/rootReducer";

const initialState = {
  isVisible: true,
};

const footerSlice = createSlice({
  name: "footerSlice",
  initialState,
  reducers: {
    setFooter(state, action: PayloadAction<boolean>) {
      if (state.isVisible !== action.payload) {
        state.isVisible = action.payload;
      }
    },
  },
});

export const { setFooter } = footerSlice.actions;

export const selectIsFooterVisible = (state: RootState) =>
  state.footer.isVisible;

export default footerSlice.reducer;
